import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import DownMark from '@/assets/icons/icon_down.svg';
import NextIcon from '@/assets/icons/icon_next_gray.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Wrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: ['52px', '52px', '68px', '68px'],
    backgroundColor: defaultTheme.background.white,
    position: 'relative',
    '.react-datepicker-popper': {
      zIndex: 10000,
    },
    '.react-datepicker-wrapper': {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '200px',
    },
  }),
);

export const DownIcon = styled.i(() =>
  mq({
    display: 'inline-block',
    width: '12px',
    height: '8px',
    marginLeft: defaultTheme.spacing.s,
    backgroundImage: `url(${DownMark})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  }),
);

export const Date = styled.time((props: { disabled: boolean }) =>
  mq({
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    padding: `${defaultTheme.spacing.xs} 0`,
    cursor: props.disabled ? 'default' : 'pointer',
    ...(props.disabled ? {} : hoverOpacity),
    '& > span': {
      fontSize: defaultTheme.font.size.l,
      fontWeight: 'bold',
      marginRigth: defaultTheme.spacing.s,
    },
  }),
);

export const NextLink = styled(Link)(() =>
  mq({
    position: 'absolute',
    left: '50%',
    transform: [
      'translateX(calc(-50% + 124px))',
      'translateX(calc(-50% + 124px))',
      'translateX(calc(-50% + 229px))',
      'translateX(calc(-50% + 229px))',
    ],
    display: 'block',
    width: '44px',
    height: '52px',
    border: 'none',
    background: `center no-repeat url(${NextIcon})`,
    backgroundSize: '11.38px 19.41px',
    ...hoverOpacity,
  }),
);

export const PrevLink = styled(NextLink)(() =>
  mq({
    transform: [
      'translateX(calc(-50% - 124px)) scaleX(-1)',
      'translateX(calc(-50% - 124px)) scaleX(-1)',
      'translateX(calc(-50% - 229px)) scaleX(-1)',
      'translateX(calc(-50% - 229px)) scaleX(-1)',
    ],
  }),
);
